'use client';

import { useState } from 'react';

export default function Toggle({
  options,
  label,
  icon,
  defaultValue,
  onChange,
  className = '',
  toggleClass = '',
  variant = 'default',
}) {
  const isSegmented = Array.isArray(options) && options.length > 0;

  const [value, setValue] = useState(
    defaultValue !== undefined ? defaultValue : isSegmented ? options[0].value : false
  );

  const update = (val) => {
    setValue(val);
    onChange && onChange(val);
  };
  const textColors =
    variant === 'primary'
      ? {
          active: 'text-black',
          inactive: 'text-[#C6C6C6]',
        }
      : {
          active: 'text-[#323232]',
          inactive: 'text-[#757575]',
        };
  /* ===============================
     SEGMENTED TOGGLE (SLIDING BG)
  =============================== */
  if (isSegmented) {
    const activeIndex = options.findIndex((opt) => opt.value === value);

    return (
      <div
        className={`relative grid w-full rounded-full bg-white p-1 overflow-hidden sm:w-fit ${className}`}
        style={{ gridTemplateColumns: '1fr 1fr' }}
      >
        {/* Sliding background */}
        <div
          className="absolute top-1 bottom-1 rounded-full bg-[#00EAFD] transition-transform duration-300 ease-out"
          style={{
            width: `calc(${100 / options.length}% - 4px)`,
            transform:
              activeIndex === 0
                ? 'translateX(4px)' //Left gap
                : 'translateX(calc(100% + 4px))', //Right gap
          }}
        />

        {options.map((opt) => {
          const active = value === opt.value;

          return (
            <button
              key={opt.value}
              onClick={() => update(opt.value)}
              className={`${toggleClass} relative z-10 xl:px-6 md:px-5 px-4 lg:py-2 py-1.5 xl:text-base md:text-sm text-[13px] font-medium cursor-pointer rounded-full transition-colors duration-300
                ${active ? textColors.active : textColors.inactive}`}
            >
              <span>{opt.label}</span>
            </button>
          );
        })}
      </div>
    );
  }

  /* ============ LABEL TOGGLE ============== */
  const isOn = Boolean(value);

  return (
    <div className={`flex items-center justify-between w-full max-w-sm ${className}`}>
      <div className="flex items-center gap-3">
        {icon}
        {label && <span className="font-semibold">{label}</span>}
      </div>

      <button
        onClick={() => update(!isOn)}
        className={`relative w-12 h-6 rounded-full transition-colors duration-300
          ${isOn ? 'bg-[#00EAFD]' : 'bg-gray-300'}`}
      >
        <span
          className={`absolute top-0.5 left-0.5 h-5 w-5 bg-white rounded-full shadow
            transition-transform duration-300
            ${isOn ? 'translate-x-6' : ''}`}
        />
      </button>
    </div>
  );
}
